<template>
    <v-dialog
      v-model="dialog"
      max-width="350"
      persistent
    >
    <div v-if="error">
        <app-message :rang="rang"  :matn="error_message" ></app-message>
    </div>
    <div v-if="dialog_firma">
        <new-firma v-on:exit_from_new_firm_dialod="dialog_firma = false"/>
    </div>
      <v-card>
        <v-form
                ref="nak"
                v-model="valid"
                @submit.prevent="save_nakladnoy"

            >
        <v-card-title class="text-h5">
          Создать документ
        </v-card-title>

        <v-card-text>

            <v-select
            v-model="nak.id_mesto"
            :items="mestaho"
            item-text="text"
            item-value="value"
            label="Выберите место"
            menu-props="auto"

            no-data-text="Не найдено"
            prepend-icon="mdi-map-marker"

            required
            :rules="MestoRules"
            ></v-select>


                <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="nak.date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="nak.date"
                label="Выберите дату"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
              v-model="nak.date"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(nak.date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>


          <v-autocomplete
          v-model="nak.firma"
          :items="firmaho"
          item-text="nom"
        item-value="id_firma"
          menu-props="auto"
          label="Выберите фирму"
          hide-details
          no-data-text="Не найдено"
          prepend-icon="mdi-car-estate"
          single-line
          required
          :rules="FirmaRules"
          @click="get_firmaho()"
          clearable
        >

    </v-autocomplete>
            <v-btn @click="dialog_firma = !dialog_firma" color="primary" text>новая фирма</v-btn>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="exit"

          >
            Отмена
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            type="submit"
            :disabled="!valid"
            :loading="loading"
          >
            Создать документ
          </v-btn>
        </v-card-actions>
    </v-form>
      </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
  export default {
    data () {
      return {

        nak: {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            firma: '',
            id_mesto: '1',
        },
        firmaho: [],
        mestaho: [],
        loading:false,
        dialog_firma: false,
        dialog: true,
        valid: false,
        menu: false,
        id_user: '',
        error: false,
        error_message: '',
        rang: '#500',

        mestaho: [
            {text: 'Магазин', value: '1'},
            {text: 'Склад', value: '2'},
        ],

        FirmaRules: [
            v => !!v || 'Выберите фирму',
          ],

          MestoRules: [
            v => !!v || 'Выберите место',
          ],
      }
    },
    mounted () {
        this.get_firmaho();
    },

    methods: {
        exit(){
            this.dialog = false;
            this.$emit('exit_kh_nakladnoy');
        },

        get_firmaho(){
            axios.get('/api/get_firmaho', {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                    this.firmaho = response.data.firmaho;
                    }else{

                        this.error = true;
                        this.error_message = "Ошибка получение группы";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {

                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

        },

        save_nakladnoy() {
            if(this.$refs.nak.validate()) {
                this.loading = true;
                //session get id_user
                //session start
                this.$session.start();
                this.id_user = this.$session.get('id_user');
                axios.post('/api/new_nakladnoy/' + this.id_user, this.nak)
                .then(response => {
                    if(response.data.status) {
                        this.loading = false;
                        this.error = true;
                        this.error_message = response.data.message;
                        this.rang = '#4CAF50';
                        this.$emit('update_nakladnoy');
                            this.dialog = false;
                            this.error = false;
                            this.error_message = '';




                    } else {
                        this.loading = false;
                        this.error = true
                        this.error_message = "Ошибка при сохранении данных"
                        setTimeout(() => {
                            this.error = false
                            this.error_message = ''
                        }, 3000)
                    }
                })
                .catch(error => {
                    this.loading = false
                    this.error = true
                    this.error_message = error.response.data.message
                    setTimeout(() => {
                        this.error = false
                        this.error_message = ''
                    }, 3000)
                })




            }else{
                
                this.error = true;
                this.error_message = 'Проверьте правильность заполнения полей';
                setTimeout(() => {
                    this.error = false;
                    this.error_message = '';
                }, 3000);
            }

        }
    },
  }
</script>

<style>

</style>




